"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
/* eslint-disable react/jsx-curly-brace-presence */
var icons_1 = require("@lift/assets/dist/assets/globals/icons");
var LftIconBase_1 = __importDefault(require("@lift/design-system-react-web/dist/components/LftIconBase"));
var react_1 = __importStar(require("react"));
var hooks_1 = require("../../hooks");
var tags_ga_1 = require("../../utils/tags-ga");
var dropdown_styles_1 = require("./dropdown.styles");
var Dropdown = function (_a) {
    var _b;
    var header = _a.header, classNameHeader = _a.classNameHeader, children = _a.children, className = _a.className, icon = _a.icon, width = _a.width, noBorder = _a.noBorder, gaCategory = _a.gaCategory, gaAction = _a.gaAction, gaLabel = _a.gaLabel, gaEventType = _a.gaEventType, testId = _a.testId, action = _a.action, tituloParaLeitorTela = _a.tituloParaLeitorTela, manterAberto = _a.manterAberto;
    var _c = (0, react_1.useState)(''), active = _c[0], setActive = _c[1];
    var _d = (0, react_1.useState)('0px'), height = _d[0], setHeight = _d[1];
    var _e = (0, react_1.useState)(false), exibirConteudo = _e[0], setExibirConteudo = _e[1];
    var _f = (0, react_1.useState)('dropdown-icon'), rotation = _f[0], setRotation = _f[1];
    var _g = (0, react_1.useState)('none'), boxShadow = _g[0], setBoxShadow = _g[1];
    var content = (0, react_1.useRef)(null);
    var sensitive = (0, react_1.useRef)(null);
    var contentOpen = ((_b = content === null || content === void 0 ? void 0 : content.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + 20 || 60;
    var toggleDropdown = (0, react_1.useCallback)(function () {
        setActive(active === '' ? 'active' : '');
        setHeight(active === 'active' ? '0px' : "".concat(contentOpen, "px"));
        setRotation(active === 'active' ? 'dropdown-icon' : 'dropdown-icon rotate');
        setBoxShadow(active === 'active' ? 'none' : '0px 0px 15px rgba(0, 0, 0, 0.05)');
    }, [active, contentOpen]);
    var closeDropdown = (0, react_1.useCallback)(function () {
        setActive('');
        setHeight('0px');
        setRotation('dropdown-icon');
        setBoxShadow('none');
        setExibirConteudo(false);
    }, []);
    (0, react_1.useEffect)(function () {
        closeDropdown();
    }, [action, closeDropdown]);
    (0, react_1.useEffect)(function () {
        setExibirConteudo(active === 'active' ? true : false);
    }, [active, exibirConteudo]);
    (0, hooks_1.useOnClickOutside)(sensitive, function () {
        if (!manterAberto) {
            closeDropdown();
        }
    });
    return (react_1.default.createElement(tags_ga_1.TagsGa, { category: gaCategory, action: gaAction, label: gaLabel, eventType: gaEventType },
        react_1.default.createElement(dropdown_styles_1.ComponentDropdownSectionStyled, { ref: sensitive, className: "".concat(active, " ").concat(className), style: { boxShadow: "".concat(boxShadow) }, width: width, noBorder: noBorder, role: "none" },
            react_1.default.createElement(dropdown_styles_1.ComponentDropdownHeaderStyled, { "data-testid": testId, className: "".concat(active, " ").concat(classNameHeader), onClick: toggleDropdown, role: "button", "aria-expanded": exibirConteudo, "aria-labelledby": "titulo-leitor-tela-".concat(testId) },
                react_1.default.createElement("span", { className: "somenteLeitorDeTela absolute", id: "titulo-leitor-tela-".concat(testId), "data-testid": "titulo-leitor-tela-".concat(testId) }, tituloParaLeitorTela),
                react_1.default.createElement(dropdown_styles_1.ComponentDropdownHeaderContentStyled, { "aria-hidden": "true", tabIndex: -1, "data-testid": "header-".concat(testId) },
                    icon !== undefined && react_1.default.createElement(dropdown_styles_1.ComponentDropdownHeaderIconStyled, null, icon),
                    react_1.default.createElement(dropdown_styles_1.ComponentDropdownHeaderTextStyled, null, header)),
                react_1.default.createElement(dropdown_styles_1.ComponentDropdownHeaderChevronStyled, { className: "".concat(active, " divIconHeaderDropdown ").concat(rotation) },
                    react_1.default.createElement(LftIconBase_1.default, { icon: icons_1.ChevronDown, size: "md" }))),
            exibirConteudo && (react_1.default.createElement(dropdown_styles_1.ComponentDropdownBodyStyled, { ref: content, style: active === ''
                    ? { boxShadow: "".concat(boxShadow), maxHeight: "".concat(height), border: 'none' }
                    : { boxShadow: "".concat(boxShadow) }, className: "".concat(active, " dropdown__content"), noBorder: noBorder, "aria-hidden": active ? 'false' : 'true', tabIndex: -1, "data-testid": "conteudo-".concat(testId) },
                children,
                react_1.default.createElement("button", { className: "somenteLeitorDeTela absolute", onClick: closeDropdown, "data-testid": "fechar-leitor-tela-".concat(testId) }, "Fechar menu"))))));
};
exports.Dropdown = Dropdown;
